import React, { useState } from 'react';
import { toaster, Notification, Modal, Button } from 'rsuite';
import { ProgressBar } from 'react-bootstrap';

import { loginService } from '../../../../services';
import { dateFns } from '../../../../helpers';

export function RecoverUserDialog ({ show, onHide, user }) {
    // State
    const [isLoading, setIsLoading] = useState(false);
    const [password, setPassword] = useState('');

    // Functions
    const recoverUser = () => {
        setIsLoading(true);

        loginService
            .recoverUser(user.id)
            .then((pass) => {
                toaster.push(<Notification type="success" header="Éxito">Usuario recuperado.</Notification>);
                setPassword(pass.extra.rawPassword);
                setIsLoading(false);
            })
            .catch(e => {
                toaster.push(<Notification type="error" header="Error">Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.</Notification>);
                console.error('Error on recover client', e);
            })
            .finally(() => {
                // change state isLoading
                setIsLoading(false);
                // closing delete modal
            });
    };

    // Main Component
    return (
        <Modal
            open={show}
            onClose={onHide}
            className={`${show ? 'show in' : ''}`}
            aria-labelledby='user-recover-modal'
        >
            <Modal.Header closeButton>
                <Modal.Title id='user-recover-modal'>
                    <>
                        <span>Desea el token para desbloquear al usuario <b>{`${user.formattedName}`}</b>?</span>
                        <br/>
                        <small>{`Fecha: ${dateFns.format(new Date(), 'dd/MM/yyyy')}`}</small>
                    </>
                </Modal.Title>
                <Modal.Body>
                    {isLoading && <span>Obteniendo token...</span>}
                    {isLoading &&
                        <ProgressBar
                            animated
                            variant='success'
                            now={100}
                            style={{ height: '3px', width: '100%' }}
                        />
                    }
                    {!isLoading && password && <span>El token es: <b>{password}</b></span>}
                </Modal.Body>
            </Modal.Header>
            <Modal.Footer>
                {!isLoading && !password && (
                    <div>
                        <Button
                            appearance="primary"
                            onClick={recoverUser}
                        >
                            <span>Obtener token</span>
                        </Button>
                        <Button
                            appearance="subtle"
                            onClick={onHide}
                        >
                            Cancelar
                        </Button>
                    </div>
                )}
                {password && (
                    <div>
                        <Button
                            appearance="subtle"
                            onClick={onHide}
                        >
                            Cerrar
                        </Button>
                    </div>
                )}
            </Modal.Footer>
        </Modal>
    );
};
